import React, {useEffect, useState} from "react";
import {Container, Grid} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";

import {fetchStatistics} from "../../../redux/actions";
import {useSelector} from "react-redux";

export const Statistics = ({city_id, subomain}) => {

    const [statistics, setStatistics] = useState({
        places: 0,
        events: 0,
        cities: 0,
    });

    const _cities = useSelector(state => state.Cities.results);

    useEffect(() => {

        const fetchData = async () => {

            try {

                // get posts
                const result = await fetchStatistics(city_id);

                // set posts
                setStatistics(result.data);

            } catch (e) {

                // show errors
                console.log('error', e);
            }
        };

        if (city_id !== 7) {
            // noinspection JSIgnoredPromiseFromCall
            fetchData();
        } else {
            const count = _cities.data.filter(o => !o.indice && !o.future).length;

            setStatistics({
                cities: count,
            })
        }

    }, [city_id, _cities]);

    const {events, places, cities} = statistics;

    return (
        <Container as="section" fluid className={`section-statistics ${subomain}`}>
            <Container>
                <Grid stackable columns="equal">
                    {
                        events > 0 && <Grid.Column textAlign="center">
                            <strong>{events}</strong> <FormattedMessage id="Eventos"/>
                        </Grid.Column>
                    }
                    {
                        places > 0 && <Grid.Column textAlign="center">
                            <strong>{places}</strong> <FormattedMessage id="Estabelecimentos"/>
                        </Grid.Column>
                    }
                    {
                        cities > 0 && <Grid.Column textAlign="center">
                            <strong>{cities}</strong> <FormattedMessage id={cities > 1 ? "Cidades" : "Cidade"}/>
                        </Grid.Column>
                    }
                </Grid>
            </Container>
        </Container>
    );
};
